// src/i18n.js
import { addMessages, init, getLocaleFromNavigator } from "svelte-i18n";

import en from "../public/static/lang/en.json";
import no from "../public/static/lang/no.json";
import pl from "../public/static/lang/pl.json";
import es from "../public/static/lang/es.json";
import fr from "../public/static/lang/fr.json";
import sv from "../public/static/lang/sv.json";

const locales = ["en", "no", "pl", "es", "fr", "sv"];
export const localeLabels = [
  { label: "Norsk", value: "no" },
  { label: "English", value: "en" },
  { label: "Polski", value: "pl" },
  { label: "Español", value: "es" },
  { label: "Français", value: "fr" },
  { label: "Svenska", value: "sv" },
];

function getLanguage(locale, locales) {
  const lang = locale.split("-");
  if (locales.includes(lang[0]?.toLowerCase())) {
    return lang[0]?.toLowerCase();
  } else if (locales.includes(lang[1]?.toLowerCase())) {
    return lang[1]?.toLowerCase();
  } else {
    return locale;
  }
}

export default function setupI18n() {
  addMessages("en", en);
  addMessages("no", no);
  addMessages("pl", pl);
  addMessages("es", es);
  addMessages("fr", fr);
  addMessages("sv", sv);
  init({
    fallbackLocale: "en",
    initialLocale:
      localStorage.getItem("language") ??
      getLanguage(getLocaleFromNavigator(), locales),
  });
}
